<error-dialog [error]="errorText" [show]="errorDialog"/>
<breadcrumb endText="Learning Objectives" [navigations]="breadcrumbNavs" />
<hr />
<!-- TODO need to create side search/filter, should be a reusable component -->
<div [ngClass]="isOpened? 'border-l p-3 flex flex-col fixed right-0 h-screen lg:w-[225px] w-[190px]' : 'border-l p-3 flex flex-col right-0 fixed h-screen'">
  <div>
    Search and Sort
  </div>
  <hr class="mb-3 mt-1 -mx-3" />
  <search-bar [style]="'flex input'" [(searchText)]="searchText" (debounceSearch)="debounceSearch()" />
  <div class="mt-2">
    <mat-checkbox [checked]="isDescending" (change)="descending(false)" [disabled]="isDescending" color="primary">Ascending</mat-checkbox>
    <mat-checkbox [checked]="!isDescending" (change)="descending(true)" [disabled]="!isDescending" color="primary">Descending</mat-checkbox>
  </div>
</div>
<div [ngClass]="isOpened? 'my-5 ml-5 lg:mr-[225px] mr-[190px]' : 'my-5 ml-5 mr-[68px]'">
  <div class="flex gap-2 items-center mb-1">
    <mat-icon fontIcon="chevron_left" class="cursor-pointer hover:bg-gray-200 rounded" (click)="CCLTree()"></mat-icon>
    <p class="font-medium text-xl mb-1">
      Learning Objectives
    </p>
  </div>
  <hr class="mb-3" />
  @if (!isLoading) {
    <div>
      @for (objective of learningObjectives; track objective) {
        <div class="mr-2 mb-1">
          <button (click)="problemTemplate(objective.learningobjective_id)" class="flex justify-between items-center w-full px-3 py-2 hover:bg-gray-200 rounded-lg">
            <div class="flex flex-col text-left">
              <div>
                {{objective.name}}
              </div>
              <div class="text-[10px] text-gray-400">
                Problem Templates: {{objective.problemtemplate_count}}
              </div>
            </div>
            <fa-icon [icon]="faChevronRight" />
          </button>
        </div>
      }
    </div>
  }
  @if (isLoading) {
    <div class="mr-2">
      <div class="w-full px-3 py-2 animate-pulse bg-gray-100 rounded-lg h-10 mb-1"></div>
      <div class="w-full px-3 py-2 animate-pulse bg-gray-100 rounded-lg h-10 mb-1"></div>
      <div class="w-full px-3 py-2 animate-pulse bg-gray-100 rounded-lg h-10 mb-1"></div>
    </div>
  }
  <div class="col-span-5 mt-1 mr-1 flex justify-end">
    @if (maxPage !== 0) {
      <div class="rounded-full bg-[#E5E8EB] w-fit px-2 py-1 text-xs text-[#74808B] flex flex-row items-center">
        <button (click)="decrementPage()" [disabled]="pageNumber === 0"><fa-icon [ngClass]="pageNumber === 0? 'text-[#B9C2CA]' : 'text-[#74808B]'" [icon]="faChevronLeft" size="xs" aria-label="Page Decrement" /></button>
        <div class="mx-1">
          Page {{pageNumber + 1}}
        </div>
        <button (click)="incrementPage()" [disabled]="maxPage === pageNumber"><fa-icon [ngClass]="maxPage === pageNumber? 'text-[#B9C2CA]' : 'text-[#74808B]'" [icon]="faChevronRight" size="xs" aria-label="Page Increment" /></button>
      </div>
    }
  </div>
</div>
